import * as React from 'react';

import { ModalXIcon, ModalXIconDark  } from '../images/images';

interface IProps {
    containerStyle?: React.CSSProperties;
    dark?: boolean;
    onClick(): void;
    isDisabled?: boolean;
}

export function CloseButton(props: IProps) {
    const isDisabledStyle = props.isDisabled ? { opacity: 0.3 } : {};
    const containerStyle = { ...styles.defaultContainer, ...props.containerStyle };

    const src = props.dark ? ModalXIconDark : ModalXIcon;
    return (
        <div style={{ ...styles.container, ...containerStyle }}>
            <button
                style={{ ...styles.buttonStyle, ...isDisabledStyle }}
                onClick={() => props.onClick()}
            >
                <img
                    src={src}
                    style={styles.modalCloseButton}
                    alt={'Close'}
                />
            </button>
        </div>
    );

}

const styles = {
    modalCloseButton: {
        width: '100%',
        objectFit: 'cover',
        cursor: 'pointer'
    } as React.CSSProperties,
    defaultContainer: {

    },
    container: {

    } as React.CSSProperties,
    buttonStyle: {
        background: 'transparent',
        height: 44,
        width: 44,
    } as React.CSSProperties,
};



// WEBPACK FOOTER //
// ./src/SharedComponents/CloseButton.tsx